import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class SearchService extends RLBaseService {
	static $inject = ["$resource"];

	constructor(private $resource: ng.resource.IResourceService) {
		super($resource);
	}

	getAdvancedMetaData(charTypeId: number, template?: string): ng.IPromise<Models.IAdvancedSearchMetaData> {
		return this.toRLService<Models.IAdvancedSearchMetaData>("/api/Search/GetCharacteristicMetaData")
			.get({ charTypeId: charTypeId, template: template }).$promise;
	}

	saveSearch(request: Models.ISaveSearchModel) {
		return this.toRLService<Models.IDataResponse<Models.ISaveSearchModel>>("/api/Search/SaveSearch")
			.post(request).$promise;
	}

	deleteSearch(request: Models.ISaveSearchModel) {
		return this.toRLService<void>("/api/Search/Delete")
			.post(request).$promise;
	}

	getSavedSearches(charTypeID?: number): ng.IPromise<Models.ISaveSearchModel[]> {
		return this.toRLService<Models.ISaveSearchModel>("/api/Search/GetSavedSearches")
			.getArray({ charTypeID: charTypeID }).$promise;
	}

	// postSearch is an action description added to construct classes so that methods on them can be used.
	advancedSearch(request: Models.IAdvancedSearchModel) {
		return this.toRLService<Models.AdvancedSearchResult>("/api/Search/AdvancedSearch").postSearch(request).$promise;
	}

	advanceSearchRelationships(request: Models.IAdvanceSearchRelationshipModel) {
		return this.toRLService<Models.AdvancedSearchResult>("/api/Search/AdvanceSearchRelationships").postSearch(request).$promise;
	}

	export(request: Models.ISearchExportModel) {
		return this.toRLService<Models.IDataResponse<boolean>>("/api/Search/Export").post(request).$promise;
	}

	debugQueryNode(charTypeID: number, queryNode: Models.IQueryNode) {
		var data = {
			charTypeID: charTypeID,
			query: queryNode
		};
		return this.toRLService<Models.IDataResponse<Models.IKeyValuePair<string, string>[]>>("/api/search/debugquerynode").post(data).$promise;
	}

	findRootModuleLevelEntity(relationship: Models.IEntityRelationship) {
		var data = {
			relationship: relationship
		};
		return this.toRLService<Models.IDataResponse<Models.IEntitySearchDoc>>("/api/search/findrootmodulelevelentity").post(data).$promise;
	}

	getEntityHierarchy(entityID: string, childCharTypeID: number, depthLevel: number) {
		const data = {
			entityID,
			depthLevel,
			childCharTypeID
		};
		return this.toRLService<Models.IDataResponse<Models.IEntityHierarchy>>("/api/search/getentityhierarchy").post(data).$promise;
	}

	getEntityParents(childEntityID: string) {
		var data = {
			entityID: childEntityID
		};
		return this.toRLService<Models.IDataResponse<Models.IEntitySearchDoc[]>>("/api/search/getentityparents").post(data).$promise;
	}

	getSolrDocForID(entityID: string) {
		var data = {
			entityID: entityID
		};
		return this.toRLService<Models.IDataResponse<Models.IEntitySearchDoc>>("/api/search/getsolrdocforid").post(data).$promise;
    }

    getSolrSearchResultForRecIDs(charTypeID: number, recordIDs: string, rowCount: number) {
        var data = {
            charTypeID: charTypeID,
            recordIDs: recordIDs,
            rowCount: rowCount
        };
        return this.toRLService<Models.AdvancedSearchResult>("/api/search/getsolrsearchresultforrecids").post(data).$promise;
    }

	syncContactPartyOnEntities(request: Models.IAdvancedSearchModel) {
		return this.toRLService<Models.IJobResponse>("/api/Search/syncContactPartyOnEntities").post(request).$promise;
	}

	getChildHierarchyCount(entityID: string) {
		const data = {
			entityID
		};

		return this.toRLService<Models.IDataResponse<number>>("/api/search/getchildhierarchycount").post(data).$promise;
	}

	getRelatedParentRecords(parentCharTypeID: number, childCharTypeID: number, childRecIDs: number[]) {
		var data = {
			parentCharTypeID: parentCharTypeID,
			childCharTypeID: childCharTypeID,
			childRecIDs: childRecIDs
		};
		return this.toRLService<Models.IDataResponse<Models.IEntitySearchDoc[]>>("/api/search/getRelatedParentRecords").post(data).$promise;
	}

	getRelatedEntityTemplates(entityID: string, childCharTypeID: number) {
		var data = {
			entityID,
			childCharTypeID
		};
		return this.toRLService<Models.ICharacteristicTemplate>("/api/search/getrelatedentitytemplates").query(data).$promise;
	}

	getChildCounts(parentCharTypeID: number, parentRecIDs: number[], childCharTypeID: number) {
		var data = {
			parentCharTypeID: parentCharTypeID,
			childCharTypeID: childCharTypeID,
			parentRecIDs: parentRecIDs
		};
		return this.toRLService<Models.IDataResponse<{ [recordID: number]: number }>>("/api/search/getChildCounts").post(data).$promise;
	}

}